export default "__VITE_ASSET__B0pD9Gg5__"